import { Check } from 'react-feather'
import clsx from 'clsx'

import type { TimelineStep } from '../lib/orderTimeline'

/**
 * Horizontal three-node progress track (Requested → Accepted → Consultation
 * ready) that visualises how far an order has travelled. It is the focal point
 * of the order detail header.
 */
export function OrderStatusTimeline({ steps }: { steps: TimelineStep[] }) {
  return (
    <ol className="flex items-start" aria-label="Order progress">
      {steps.map((step, index) => {
        const isLast = index === steps.length - 1
        const isDone = step.state === 'done'
        const isCurrent = step.state === 'current'

        return (
          <li key={step.key} className={clsx('flex flex-col items-center', !isLast && 'flex-1')}>
            <div className="flex w-full items-center">
              <span
                className={clsx(
                  'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 text-sm font-semibold transition-colors',
                  isDone && 'border-primary bg-primary text-white',
                  isCurrent && 'border-primary bg-white text-primary',
                  !isDone && !isCurrent && 'border-gray-200 bg-white text-gray-400'
                )}
                aria-current={isCurrent ? 'step' : undefined}
              >
                {isDone ? <Check size={16} strokeWidth={3} aria-hidden="true" /> : index + 1}
                {isCurrent && <span className="absolute h-9 w-9 animate-ping rounded-full bg-primary/20" aria-hidden="true" />}
              </span>
              {!isLast && <span className={clsx('mx-2 h-0.5 flex-1 rounded-full transition-colors', isDone ? 'bg-primary' : 'bg-gray-200')} />}
            </div>
            <span
              className={clsx(
                'mt-2 max-w-[6.5rem] text-center text-xs font-medium sm:max-w-none sm:text-sm',
                isDone || isCurrent ? 'text-gray-900' : 'text-gray-400'
              )}
            >
              {step.label}
            </span>
          </li>
        )
      })}
    </ol>
  )
}
